<template>
  <v-row>
    <v-col cols="12">
      <h3>{{ $t('multiDayDiscountOverwriteModal.multiDayDiscount') }}</h3>
    </v-col>
    <v-col cols="12" class="d-flex justify-space-between">
      <span class="caption white-opacity-text">
        {{ $t('multiDayDiscountOverwriteModal.multiDayDiscountFacotrHelp') }}
      </span>
      <span class="caption white-opacity-text">
        {{ factor.toFixed(3) }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'DiscountFactorHelpTooltip',
  props: {
    /**
     * array of MultiDayDiscount objects
     */
    factor: {
      required: true,
      type: Number,
    },
  },
})
</script>
